import { render, staticRenderFns } from "./IconArrowRightSmall.vue?vue&type=template&id=ae1b8d44&"
import script from "./IconArrowRightSmall.vue?vue&type=script&lang=js&"
export * from "./IconArrowRightSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae1b8d44')) {
      api.createRecord('ae1b8d44', component.options)
    } else {
      api.reload('ae1b8d44', component.options)
    }
    module.hot.accept("./IconArrowRightSmall.vue?vue&type=template&id=ae1b8d44&", function () {
      api.rerender('ae1b8d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconArrowRightSmall.vue"
export default component.exports